<template>
  <div ref="myEcharts" style="width: 100%;height: 100%"></div>
</template>

<script>
import * as echarts from 'echarts'

/**
 * option 为图表的整体配置项 
 * type 为图表类型 
 */
export default {
  props: {
    option: {
      type: Object,
      default: () => { }
    },
    type: {
      type: String,
    },
  },
  data() {
    return {
      myEcharts: null,
      chartInstance: null

    };
  },

  created() {
    this.$nextTick(() => {
     console.log(this.option)
      if (this.$refs.myEcharts) {
        this.chartInstance = echarts.init(this.$refs.myEcharts);
        if (this.option) {
          this.updateChart();
        }
        window.addEventListener('resize', this.resizeEcharts)
      }
    })
  },
  watch: {
    option() {
      this.updateChart()
    }
  },
  methods: {
    updateChart() {
      if (this.chartInstance && this.option) {
        console.log(this.option)
        this.chartInstance.setOption(this.option, true);
      }
    },
    resizeEcharts() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    }
  },
  onUnmounted() {
    if (this.chartInstance) {

      this.chartInstance.dispose()
    }
    window.removeEventListener('resize', this.resizeEcharts)
  }
}

















</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/Hcomponents/HEcharts/index.vue